import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";

const StnInwardView_report = () => {
   useAuthRedirect();
  const { stnNo, stnBranch } = useParams();
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");

  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchIndentDetails = async () => {
      try {
        const response = await axios.get(
          `https://rfs2.infraconsoft.net.in/api/stnInward_detailsHeader?stnNo=${stnNo}&branch=${branch}`
        );
        if (response.data && response.data.headerDetails?.length > 0) {
          const items = response.data.headerDetails;
          const storeReqHeader = {
            headerNo: items[0].sfIssuesHeader_number,
            type: items[0].sfIssuesHeader_type,
            transferBranch: items[0].sfIssuesHeader_branchcode,
            InwardDate: items[0].sfIssuesHeader_date,
            indentNo: items[0].sfIssuesHeader_indentNumber,
            remarks: items[0].sfIssuesHeader_remarks,
            shift: items[0].sfissuesHeader_shiftNumber,
          };
          setHeader(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchIndentDetails();
  }, [stnNo, branch]);

const [loading, setLoading] = useState(true);

useEffect(() => {
  setLoading(true); // start loading
  axios
    .get(`https://rfs2.infraconsoft.net.in/api/stnInward_listData?stnNo=${stnNo}&branch=${stnBranch}`)
    .then((response) => {
      setData(response.data.bottomDetails || []);
      setLoading(false); // stop loading
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
      setData([]);
      setLoading(false);
    });
}, [stnNo, stnBranch]);


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section> <div className="back-div">
                                          <h2 className="add-txt">STN Inward - Report</h2>
                                          <Link to={`/inventory/stockTransferNote_report`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                                        </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Store Issue No :</label>
                <input type="text" name="indentNo" value={header.headerNo} readOnly />
              </div>
              <div className="form-group">
                <label>Stock Transferred Date :</label>
                <input type="text"value={header.InwardDate ? new Date(header.InwardDate).toISOString().split("T")[0] : ""} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Stock Transfer From :</label>
                <input type="text" name="type" value={stnBranch} readOnly />
              </div>
              <div className="form-group">
                <label>Type :</label>
                <input type="text" name="branch" value={header.type} readOnly />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.remarks} readOnly/>
              </div>

              <div className="form-group">
                <label>Shift :</label>
                <input type="text" value={header.shift} readOnly/>
              </div>
            </div>

           

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="9" style={{ textAlign: "center" }}>Loading...</td>
    </tr>
  ) : data.length > 0 ? (
    <>
      {data.map((item, index) => {
        const value = item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity;
        return (
          <tr key={index}>
            <td>{index + 1}</td>
            <td>{item.sfissuesDetail_itemCode}</td>
            <td>{item.itemmaster_name}</td>
            <td>{item.itemmaster_uom}</td>
            <td>{item.sfissuesDetail_issuedQuantity}</td>
            <td>{item.sfIssuesDetail_price}</td>
            <td>{value.toFixed(2)}</td>
          </tr>
        );
      })}
      <tr>
        <td colSpan={6}><strong>Total Value</strong></td>
        <td>
          <strong>
            {data
              .reduce(
                (acc, item) =>
                  acc + item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity,
                0
              )
              .toFixed(2)}
          </strong>
        </td>
      </tr>
    </>
  ) : (
    <tr>
      <td colSpan="9" style={{ textAlign: "center" }}>No items</td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StnInwardView_report;
